export var formatWeekdayName = function (weekday) {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[weekday.getDay()].substring(0, 3);
};
export var parseDateToSimpleFormat = function (selectedDay, format) {
    if (!selectedDay)
        return undefined;
    var year = selectedDay.getFullYear();
    var month = selectedDay.getMonth() + 1;
    var day = selectedDay.getDate();
    var paddedMonth = month.toString().padStart(2, '0');
    var paddedDay = day.toString().padStart(2, '0');
    if (format === 'MM/dd/yyyy') {
        return "".concat(paddedMonth, "/").concat(paddedDay, "/").concat(year);
    }
    return "".concat(paddedDay, "/").concat(paddedMonth, "/").concat(year);
};
